import scheduleISpiroEventPopupComponent from './scheduleISpiroEventPopup.component';

const scheduleISpiroEventPopupModule = angular.module('app.components.scheduleISpiroEventPopup', [])
	.component('scheduleISpiroEventPopup', scheduleISpiroEventPopupComponent)
	.name;

export default scheduleISpiroEventPopupModule;
